import { NgModule } from 'ng-metadata/core';
import { CheckoutShippingComponent } from './shipping.component';

@NgModule({
  declarations: [
    CheckoutShippingComponent,
  ],
})
export class CheckoutShippingModule {} 



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/shipping/shipping.module.ts